<template>
	<div class="animated fadeIn">
		<b-card>
			<vue-loading :active.sync="afterSalesOrdersTableProps.isLoading" :is-full-page="false"/>
			<vue-loading :active.sync="isLoadingDeleting" :is-full-page="false"/>
			<div slot="header">
				<div class="card-header-actions">
					<CLink title="Osveži tabelo" href="#" class="card-header-action btn-setting" @click.stop="click_afterSalesOrdersTableRefresh">
						<CIcon name="cil-loop-circular" class="mb-1"/>
					</CLink>
					<CLink title="Ponastavi filtre" href="#" class="card-header-action btn-setting" @click.stop="click_afterSalesOrdersTableResetFilters">
						<CIcon name="cil-x" class="mb-1"/>
					</CLink>
					<CLink title="Dodaj delovni nalog" href="#" class="card-header-action btn-setting" @click.stop="click_afterSalesOrderCreate">
						<CIcon name="cil-plus" class="mb-1"/>
					</CLink>
				</div>
			</div>
			<b-table
				class="afterSalesOrderTable"
				ref="afterSalesOrdersTable"
				responsive
				show-empty
				hover
				:empty-text="afterSalesOrdersTableProps.empty_text"
				:empty-filtered-text="afterSalesOrdersTableProps.empty_filtered_text"
				:fields="afterSalesOrdersTableFields"
				:current-page="afterSalesOrdersTableProps.currentPage"
				:per-page="afterSalesOrdersTableProps.itemsPerPage"
				:items="afterSalesOrdersTable_items"
				:sort-by.sync="afterSalesOrdersTableProps.sortBy"
				:sort-desc.sync="afterSalesOrdersTableProps.sortDesc"
				@row-clicked="rowClicked">
				<template slot="top-row">
					<td><b-form-input v-model="afterSalesOrdersTableProps.inputFilter.orderNumber" type="text" @input="afterSalesOrdersTableTextFilter_change"/></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
				</template>
				<template v-slot:cell(actions)="data">
					<b-button title="Posodobi vrstico" variant="primary" @click.stop="click_afterSalesOrderUpdate(data.item.order_number)" size="sm" class="mr-2">
						<CIcon name="cil-loop-circular"/>
					</b-button>
				</template>
				<template v-slot:cell(dates)="data">
					<div>appointment_date: <b-badge variant="info">{{ data.item.appointment_date ? $options.filters.viewDate(data.item.appointment_date) : '/' }}</b-badge></div>
					<div>create_date: <b-badge variant="info">{{ data.item.create_date ? $options.filters.viewDate(data.item.create_date) : '/' }}</b-badge></div>
					<div>accept_date: <b-badge variant="info">{{ data.item.accept_date ? $options.filters.viewDate(data.item.accept_date) : '/' }}</b-badge></div>
					<div>completed_date: <b-badge variant="info">{{ data.item.completed_date ? $options.filters.viewDate(data.item.completed_date) : '/' }}</b-badge></div>
					<div>pickup_date: <b-badge variant="info">{{ data.item.pickup_date ? $options.filters.viewDate(data.item.pickup_date) : '/' }}</b-badge></div>
					<div>invoiced_date: <b-badge variant="info">{{ data.item.invoiced_date ? $options.filters.viewDate(data.item.invoiced_date) : '/' }}</b-badge></div>
				</template>
				<template v-slot:cell(prices)="data">
					<div>price_excl_vat: <b-badge variant="info">{{ data.item.price_excl_vat ? $options.filters.hr_money(data.item.price_excl_vat) : '/' }}</b-badge></div>
					<div>price_discounted_excl_vat: <b-badge variant="info">{{ data.item.price_discounted_excl_vat ? $options.filters.hr_money(data.item.price_discounted_excl_vat) : '/' }}</b-badge></div>
					<div>price_discounted_incl_vat: <b-badge variant="info">{{ data.item.price_discounted_incl_vat ? $options.filters.hr_money(data.item.price_discounted_incl_vat) : '/' }}</b-badge></div>
				</template>
				<template v-slot:cell(order)="data">
					<div>order_type: <b-badge variant="info">{{ data.item.order_type ? data.item.order_type : '/'}}</b-badge></div>
					<div>order_invoicing_type: <b-badge variant="info">{{ data.item.order_invoicing_type ? data.item.order_invoicing_type : '/' }}</b-badge></div>
				</template>
				<template v-slot:cell(customer)="data">
					<div>customer_code: <b-badge variant="info">{{ data.item.customer_code ? data.item.customer_code : '/' }}</b-badge></div>
					<div>customer_name: <b-badge variant="info">{{ data.item.customer_name ? data.item.customer_name : '/' }}</b-badge></div>
				</template>
				<template v-slot:cell(vehicle)="data">
					<div>vehicle_vin: <b-badge variant="info">{{ data.item.vehicle_vin ? data.item.vehicle_vin : '/' }}</b-badge></div>
					<div>vehicle_model_code: <b-badge variant="info">{{ data.item.vehicle_model_code ? data.item.vehicle_model_code : '/' }}</b-badge></div>
					<div>vehicle_model_description: <b-badge variant="info">{{ data.item.vehicle_model_description ? data.item.vehicle_model_description : '/' }}</b-badge></div>
					<div>vehicle_make_id: <b-badge variant="info">{{ data.item.vehicle_make_id ? data.item.vehicle_make_id : '/' }}</b-badge></div>
					<div>vehicle_make_description: <b-badge variant="info">{{ data.item.vehicle_make_description ? data.item.vehicle_make_description : '/' }}</b-badge></div>
				</template>
				<template v-slot:cell(cdp_status)="data">
					<div>status_code_additional: <b-badge variant="info">{{ data.item.cdp_status_code_additional ? data.item.cdp_status_code_additional : '/' }}</b-badge></div>
					<div>open: <b-badge variant="info">{{ data.item.cdp_status_open ? 'Da' : 'Ne' }}</b-badge></div>
					<div>open_completed: <b-badge variant="info">{{ data.item.cdp_status_open_completed ? 'Da' : 'Ne' }}</b-badge></div>
					<div>invoiced: <b-badge variant="info">{{ data.item.cdp_status_invoiced ? 'Da' : 'Ne' }}</b-badge></div>
					<div>closed: <b-badge variant="info">{{ data.item.cdp_status_closed ? 'Da' : 'Ne' }}</b-badge></div>
					<div>credited: <b-badge variant="info">{{ data.item.cdp_status_credited ? 'Da' : 'Ne' }}</b-badge></div>
					<div>canceled: <b-badge variant="info">{{ data.item.cdp_status_canceled ? 'Da' : 'Ne' }}</b-badge></div>
					<div>customer_waiting: <b-badge variant="info">{{ data.item.cdp_status_customer_waiting ? 'Da' : 'Ne' }}</b-badge></div>
				</template>
				<template v-slot:cell(service_advisor)="data">
					<div>service_advisor_id: <b-badge variant="info">{{ data.item.service_advisor_id ? data.item.service_advisor_id : '/' }}</b-badge></div>
					<div>service_advisor_first_name: <b-badge variant="info">{{ data.item.service_advisor_first_name ? data.item.service_advisor_first_name : '/' }}</b-badge></div>
					<div>service_advisor_last_name: <b-badge variant="info">{{ data.item.service_advisor_last_name ? data.item.service_advisor_last_name : '/' }}</b-badge></div>
					<div>service_advisor_user_id: <b-badge variant="info">{{ data.item.service_advisor_user_id ? data.item.service_advisor_user_id : '/' }}</b-badge></div>
				</template>
				<template v-slot:cell(status)="data">
					<b-badge variant="info">/</b-badge>
				</template>
			</b-table>
			<nav>
				<b-row>
					<b-col></b-col>
					<b-col cols=2>
						<a class="page-link rows_total float-right">Št. vrstic: {{ afterSalesOrdersTableProps.totalItems }}</a>
					</b-col>
				</b-row>
			</nav>
		</b-card>
		<vue-toastr ref="toastr"></vue-toastr>
		<after-sales-order-import-update-modal ref="afterSalesOrderCreateEditModal" @emit_afterSalesOrderCreatedOrEdited="emit_afterSalesOrderCreatedOrEdited"/>
	</div>
</template>

<script>
import settings from '@/settings.js';
import imagesTool from '@/tools/images';
import AfterSalesOrderImportUpdate from '@/views/modals/AfterSalesOrderImportUpdate';
import { AFTER_SALES_ORDERS_LIST_FILTERED, AFTER_SALES_ORDER_IMPORT_OR_UPDATE } from "@/store/actions/afterSalesOrders";

export default {
	name: 'after-sales-orders',
	components: {
		'after-sales-order-import-update-modal': AfterSalesOrderImportUpdate
	},
	data () {
		return {
			settings,
			imagesTool,
			afterSalesOrdersTableProps: {
				sortDesc: true,
				sortBy: '',
				currentPage: 1,
				itemsPerPage: 100,
				totalItems: 0,
				isLoading: false,
				options_numRowsOnPage: [
					{ value: 50, text: '50' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' },
					{ value: 1000, text: '1000' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				inputFilter: {
					orderNumber: null
				},
				textFilterTimeout: null,
				errorText: ''
			},
			isLoadingDeleting: false
		}
	},
	computed: {
		profile() {
			return this.$store.getters.getProfile
		},
		afterSalesOrdersTableFields: function () {
			let fields = [];
			fields.push({ key: 'order_number', label: 'Št. Delovnega naloga', sortable: false, class: '' });
			fields.push({ key: 'internal_id', label: 'Status', sortable: false, class: '' });
			fields.push({ key: 'dates', label: 'Datumi', sortable: false, class: 'tdAfterSalesOrdersDates' });
			fields.push({ key: 'currency_company', label: 'currency_company', sortable: false, class: '' });
			fields.push({ key: 'order', label: 'order', sortable: false, class: 'tdAfterSalesOrder' });
			fields.push({ key: 'amount', label: 'amount', sortable: false, class: '' });
			fields.push({ key: 'prices', label: 'prices', sortable: false, class: 'tdAfterSalesOrdersPrices' });
			fields.push({ key: 'cdp_status', label: 'cdp_status', sortable: false, class: 'tdAfterSalesOrdersCdpStatus' });
			fields.push({ key: 'customer', label: 'customer', sortable: false, class: 'tdAfterSalesOrdersCustomer' });
			fields.push({ key: 'service_advisor', label: 'service_advisor', sortable: false, class: 'tdAfterSalesOrdersServiceAdvisor' });
			fields.push({ key: 'actions', label: '#', sortable: false, class: 'tdAfterSalesOrderActions text-right' });
			return fields;
		}
	},
	methods: {
		click_afterSalesOrdersTableRefresh: function () {
			this.afterSalesOrdersTableProps.itemsPerPage = this.afterSalesOrdersTableProps.options_numRowsOnPage[1].value;
			this.$refs.afterSalesOrdersTable.refresh();
		},
		click_afterSalesOrdersTableResetFilters: function () {
			this.afterSalesOrdersTableProps.inputFilter.orderNumber = null;
			this.click_afterSalesOrdersTableRefresh();
		},
		afterSalesOrdersTable_items: function (ctx) {
			this.afterSalesOrdersTableProps.isLoading = true;
			return this.$store.dispatch(AFTER_SALES_ORDERS_LIST_FILTERED, { ctx: ctx, tableProps: this.afterSalesOrdersTableProps })
				.then((responseData) => {
					this.afterSalesOrdersTableProps.isLoading = false;
					this.afterSalesOrdersTableProps.items = responseData.afterSalesOrdersPagination.data;
					this.afterSalesOrdersTableProps.totalItems = responseData.afterSalesOrdersPagination.total;
					this.afterSalesOrdersTableProps.empty_text = 'Ni vnosov';
					return responseData.afterSalesOrdersPagination.data;
				})
				.catch(error => {
					this.afterSalesOrdersTableProps.isLoading = false;
					this.afterSalesOrdersTableProps.items = [];
					this.afterSalesOrdersTableProps.totalItems = 0;
					this.afterSalesOrdersTableProps.empty_text = 'Napaka pri pridobivanju delovnih nalogov';
					console.log(error);
					return [];
				});
		},
		afterSalesOrdersTableTextFilter_change: function (value) {
			if (this.afterSalesOrdersTableProps.textFilterTimeout !== null) {
				clearTimeout(this.afterSalesOrdersTableProps.textFilterTimeout);
			}
			this.afterSalesOrdersTableProps.textFilterTimeout = setTimeout(() => {
				this.click_afterSalesOrdersTableRefresh();
			}, settings.filterTimeoutLength);
		},
		afterSalesOrdersTableFilter_change: function (value) {
			this.click_afterSalesOrdersTableRefresh();
		},
		rowClicked (row) {
			let modalInput = {
				mode: 2, // update mode
				afterSalesOrder: row
			}
			this.$refs.afterSalesOrderCreateEditModal.showModal(modalInput);
		},
		click_afterSalesOrderCreate: function () {
			let modalInput = {
				mode: 1, // normal mode
				afterSalesOrder: null
			}
			this.$refs.afterSalesOrderCreateEditModal.showModal(modalInput);
		},
		click_afterSalesOrderUpdate: function (orderNumber) {
			this.afterSalesOrdersTableProps.isLoading = true;
			this.$store.dispatch(AFTER_SALES_ORDER_IMPORT_OR_UPDATE, { orderNumber })
				.then((responseData) => {
					this.$refs.toastr.s('Delovni nalog št. ' + orderNumber + ' uspešno podoboljen');
					this.$refs.afterSalesOrdersTable.refresh();
				})
				.catch(error => {
					this.afterSalesOrdersTableProps.isLoading = false;
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.$refs.toastr.e('Napaka pri posodabljanju delovnega naloga! (' + error.response.data.code + ')');
					} else {
						this.$refs.toastr.e('Napaka pri posodabljanju delovnega naloga!');
					}
				});
		},
		emit_afterSalesOrderCreatedOrEdited: function (data) {
			//if (data.message == 'edited') this.$refs.toastr.s('Nadomestno vozilo #' + data.afterSalesOrder.vin + ' uspešno urejeno.');
			this.$refs.afterSalesOrdersTable.refresh();
		},
	},
	created: function () {
	},
	mounted() {
	}
}
</script>
<style scoped>
.table-responsive-sm {
	margin-bottom: 0;
}
.pagination {
	margin-left: 1rem;
	margin-right: 1rem;
}
.page-link.rows_total {
	text-align: center;
	border-radius: 5px;
	width: 120px;
}
</style>
<style>
.tdAfterSalesOrderVin {
	width: 13rem;
	min-width: 13rem;
}
.tdAfterSalesOrdersDates {
	width: 13rem;
	min-width: 13rem;
}
.tdAfterSalesOrder {
	width: 15rem;
	min-width: 15rem;
}
.tdAfterSalesOrdersPrices {
	width: 16rem;
	min-width: 16rem;
}
.tdAfterSalesOrdersCustomer {
	width: 16rem;
	min-width: 16rem;
}
.tdAfterSalesOrdersCdpStatus {
	width: 13rem;
	min-width: 13rem;
}
.tdAfterSalesOrdersServiceAdvisor {
	width: 17rem;
	min-width: 17rem;
}
.tdAfterSalesOrderActions {
	width: 11rem;
	min-width: 11rem;
}
.afterSalesOrderTable {
	min-height: 500px;
}
.table thead th[aria-sort="descending"] {
    cursor: pointer;
}
.table thead th[aria-sort="descending"] div:after {
	content:'↓';
	margin-left: 0.5em;
}
.table thead th[aria-sort="ascending"] {
    cursor: pointer;
}
.table thead th[aria-sort="ascending"] div:after {
	content:'↑';
	margin-left: 0.5em;
}
.table thead th[aria-sort="none"] {
    cursor: pointer;
}
</style>